import React, { useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import { Button, Modal } from "react-bootstrap";
import * as Yup from "yup";
import TextField from "../../textField/TextField";
import makeRequest from "../../../utils/makeRequest";
import * as urls from "../../../utils/URLConst";
import toastNotify from "../../../utils/ToastNotify";
import { useDispatch } from "react-redux";
import { handleLoader } from "../../../redux/reducers/layout";


const AddProductModal = ({
  isOpen,
  handleIsProductMdl,
  fetchProductList
}) => {

  const dispatch = useDispatch();

  async function addProducts(val) {
    try {
      dispatch(handleLoader(true));
      const config = {};
      var payload = {
        ITEM_NM: val.productNm,
      };
      const result = await makeRequest(
        "POST",
        urls.setClientVederProduct,
        payload,
        config
      );
      if (result.STATUS === "0") {
        toastNotify(result.MESSAGE, "success");
        fetchProductList();
        handleIsProductMdl();
      } else {
        toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // Ingore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }

  return (
    <Modal
      backdrop="static"
      keyboard={false}
      size="sm"
      show={isOpen}
      onHide={handleIsProductMdl}
    >
      <Modal.Header closeButton>
        <Modal.Title>Add New Product</Modal.Title>
      </Modal.Header>

      <Formik
        enableReinitialize={true}
        initialValues={{ productNm: "" }}
        validationSchema={Yup.object({
          productNm: Yup.string().required("Product Name is required field.")
        })}
        onSubmit={(values) => {
          addProducts(values);
        }}
      >
        {({ values, handleChange, handleBlur }) => (
          <Form>
            <Modal.Body>
              <TextField
                label="Product Name"
                name="productNm"
                id="productNm"
                required
                maxLength={50}
                value={values.productNm}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <ErrorMessage
                name="productNm"
                component="div"
                className="invalid-feedback"
              />
            </Modal.Body>

            <Modal.Footer className=" py-2">
              <Button
                variant="primary"
                type="submit"
                className=" btn-sm"
              >
                Submit
              </Button>
              <Button
                variant="secondary"
                type="button"
                className="btn-sm"
                onClick={handleIsProductMdl}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal >
  );
};

export default AddProductModal;
